import { createContext } from 'react';

export interface CardContextType {
  isMobile: boolean;
  isWidget: boolean;
}

export const CardContext = createContext<CardContextType>({
  isMobile: false,
  isWidget: false,
});
